<template>
  <v-app>
    <v-navigation-drawer
      app
      class="elevation-2"
      width="310"
      v-model="sidebar.open"
    >
      <v-list rounded>
        <v-subheader>MAIN MENU</v-subheader>
        <v-list-item-group color="primary">
          <template v-for="(item, i) in sidebar.items">
            <v-list-group
              v-if="item.children"
              :key="i"
              :prepend-icon="item.icon"
            >
              <template slot="activator">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </template>
              <v-list-item
                v-for="(child, j) in item.children"
                :key="j"
                :to="child.path"
                dense
              >
                <v-list-item-icon>
                  <v-icon>mdi-minus</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ child.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item v-else :key="'-' + i" :to="item.path">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item to="/profil">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Profil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/whatsapp" v-if="isAdmin">
            <v-list-item-icon>
              <v-icon>mdi-whatsapp</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>WA Gateway</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="modal.logout = true">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="primary accent-4" dark app>
      <v-app-bar-nav-icon @click="toggleSidebar"></v-app-bar-nav-icon>

      <v-toolbar-title>JURNAL MENGAJAR</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            <v-icon class="mr-2">mdi-account</v-icon>
            {{ userNama }}
          </v-btn>
        </template>

        <v-list width="200">
          <v-list-item to="/profil">
            <v-list-item-content>
              <v-list-item-title>Profil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="modal.logout = true">
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main class="grey lighten-5">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-dialog v-model="modal.logout">
      <v-card width="500">
        <v-card-title>Logout</v-card-title>
        <v-card-text>
          <p>Anda yakin akan logout?</p>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="red" @click="logout">Keluar</v-btn>
          <v-btn text @click="modal.logout = false">Batal</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      modal: {
        logout: false,
      },
      sidebar: {
        open: true,
        items: [],
      },
      darkMode: true,
      userNama: "",
      isAdmin: localStorage.getItem("xlevel") == "admin",
    };
  },
  created() {
    this.auth();
    this.checkLevel();
  },
  methods: {
    async auth() {
      if (!this.$root.app.xid) {
        this.$router.replace("/login");
        return 0;
      }

      const res = await this.$root.app.http.get(
        "/api/guru/" + this.$root.app.xid
      );
      const namas = res.data.nama.split(" ");
      this.userNama = namas[0];
    },
    toggleSidebar() {
      this.sidebar.open = !this.sidebar.open;
    },
    handlePage(path) {
      if (path == "logout") {
        this.logout();
      } else {
        this.$router.push(path);
      }
    },
    logout() {
      localStorage.removeItem("xid");
      localStorage.removeItem("xlevel");
      window.location = "./";
    },
    checkLevel() {
      if (this.$root.app.xlevel == "admin") {
        this.sidebar.items = [
          {
            title: "Dashboard",
            icon: "mdi-home-city",
            path: "/",
          },
          {
            title: "Data Master",
            icon: "mdi-school",
            children: [
              {
                title: "Data Guru",
                path: "/data/guru",
              },
              {
                title: "Data Rombel",
                path: "/data/rombel",
              },
              {
                title: "Data Siswa",
                path: "/data/siswa",
              },
              {
                title: "Data Mata Pelajaran",
                path: "/data/matapelajaran",
              },
              // {
              //   title: "Data Jam KBM",
              //   path: "/data/jamkbm",
              // },
              {
                title: "Tahun Ajaran",
                path: "/data/tahunajaran",
              },
            ],
          },
          // {
          //   title: "Jadwal Mengajar",
          //   icon: "mdi-calendar",
          //   children: [
          //     {
          //       title: "Entri Jadwal Mengajar",
          //       path: "/jadwal/entri",
          //     },
          //     {
          //       title: "List Jadwal Mengajar",
          //       path: "/jadwal/list",
          //     },
          //   ],
          // },
          {
            title: "Jurnal Mengajar",
            icon: "mdi-table",
            children: [
              {
                title: "Entri Jurnal",
                path: "/jurnal/entri",
              },
              {
                title: "List Jurnal",
                path: "/jurnal/list",
              },
              {
                title: "Anulir Presensi",
                path: "/jurnal/anulir",
              },
            ],
          },
          {
            title: "Rekapitulasi",
            icon: "mdi-archive",
            children: [
              {
                title: "Rekap Jurnal Bulanan",
                path: "/rekap/jurnalbulanan",
              },
              {
                title: "Rekap Absensi Siswa",
                path: "/rekap/absensisiswa",
              },
              {
                title: "Rekap Anulir Siswa",
                path: "/rekap/anulirsiswa",
              },
            ],
          },
        ];
      } else if (this.$root.app.xlevel == "bk") {
        this.sidebar.items = [
          {
            title: "Dashboard",
            icon: "mdi-home-city",
            path: "/",
          },
          {
            title: "Jadwal Mengajar",
            icon: "mdi-calendar",
            children: [
              {
                title: "Entri Jadwal Mengajar",
                path: "/jadwal/entri",
              },
              {
                title: "List Jadwal Mengajar",
                path: "/jadwal/list",
              },
            ],
          },
          {
            title: "Jurnal Mengajar",
            icon: "mdi-table",
            children: [
              {
                title: "Entri Jurnal",
                path: "/jurnal/entri",
              },
              {
                title: "List Jurnal",
                path: "/jurnal/list",
              },
              {
                title: "Anulir Presensi",
                path: "/jurnal/anulir",
              },
            ],
          },
          {
            title: "Rekapitulasi",
            icon: "mdi-archive",
            children: [
              {
                title: "Rekap Jurnal Bulanan",
                path: "/rekap/jurnalbulanan",
              },
              {
                title: "Rekap Absensi Siswa",
                path: "/rekap/absensisiswa",
              },
              {
                title: "Rekap Anulir Siswa",
                path: "/rekap/anulirsiswa",
              },
            ],
          },
        ];
      } else {
        this.sidebar.items = [
          {
            title: "Dashboard",
            icon: "mdi-home-city",
            path: "/",
          },
          {
            title: "Jadwal Mengajar",
            icon: "mdi-calendar",
            children: [
              {
                title: "Entri Jadwal Mengajar",
                path: "/jadwal/entri",
              },
              {
                title: "List Jadwal Mengajar",
                path: "/jadwal/list",
              },
            ],
          },
          {
            title: "Jurnal Mengajar",
            icon: "mdi-table",
            children: [
              {
                title: "Entri Jurnal",
                path: "/jurnal/entri",
              },
              {
                title: "List Jurnal",
                path: "/jurnal/list",
              },
            ],
          },
          {
            title: "Rekapitulasi",
            icon: "mdi-archive",
            children: [
              {
                title: "Rekap Jurnal Bulanan",
                path: "/rekap/jurnalbulanan",
              },
              {
                title: "Rekap Absensi Siswa",
                path: "/rekap/absensisiswa",
              },
              {
                title: "Rekap Anulir Siswa",
                path: "/rekap/anulirsiswa",
              },
            ],
          },
        ];
      }
    },
  },
};
</script>
